import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../components/Sidebar';
import './Inventory.css';

function Inventory({ onLogout }) {
  const navigate = useNavigate();
  const [showMoreModal, setShowMoreModal] = useState(false);

  const inventoryCategories = [
    {
      id: 1,
      icon: '\u{1F527}',
      name: 'Parts',
      description: 'Manage auto parts inventory',
      path: '/inventory/parts',
      stock: 0,
      value: 1340,
    },
    {
      id: 2,
      icon: '\u{1F50B}',
      name: 'Tires/Batterys',
      description: 'Track tires and batteries inventory',
      path: '/inventory/tires',
      records: 0,
      stock: 0,
    },
    {
      id: 3,
      icon: '\u{1F9F0}',
      name: 'Labor',
      description: 'Common labor services you offer',
      path: '/inventory/labor',
      records: 0,
    },
    {
      id: 4,
      icon: '\u{1F4E6}',
      name: 'Canned Jobs',
      description: 'Bundle parts and labor into packages',
      path: '/inventory/canned-jobs',
    },
    {
      id: 5,
      icon: '\u{1F3E2}',
      name: 'Business Assets',
      description: 'Manage your tools, equipment and other assets',
      path: '/inventory/business-assets',
    },
  ];

  const moreOptions = [
    {
      id: 1,
      icon: '\u{1F6D2}',
      name: 'Purchase Parts',
      path: '/inventory/purchase',
    },
    {
      id: 2,
      icon: '\u{1F4E4}',
      name: 'Issue Parts',
      path: '/inventory/issue-parts',
    },
    {
      id: 3,
      icon: '\u{1F4CB}',
      name: 'View All Issue Parts',
      path: '/inventory/issued-parts',
    },
    {
      id: 4,
      icon: '\u{1F9FE}',
      name: 'View All Purchases',
      path: '/inventory/purchases',
    },
    {
      id: 5,
      icon: '\u{1F4CA}',
      name: 'Inventory Reports',
      path: '/reports',
    },
  ];

  const handleMoreOptionClick = (path) => {
    setShowMoreModal(false);
    navigate(path);
  };

  return (
    <div className="home-container">
      <Sidebar onLogout={onLogout} />
      <div className="main-section">
        <div className="inventory-container">
          <header className="inventory-header app-page-header">
            <div className="app-title-group">
              <button className="app-back-button" onClick={() => navigate('/')} aria-label="Back to home" />
              <div className="app-title-copy">
                <h1>Inventory</h1>
                <p>Parts, labor, purchases, and stock tools.</p>
              </div>
            </div>
            <div className="app-header-actions">
              <button className="btn-more" onClick={() => navigate('/reports')}>Report</button>
              <button className="btn-more" onClick={() => setShowMoreModal(true)}>More</button>
            </div>
          </header>

          <div className="inventory-grid">
            {inventoryCategories.map((category) => (
              <div
                key={category.id}
                className="inventory-card"
                onClick={() => navigate(category.path)}
              >
                <div className="card-icon">{category.icon}</div>
                <h3 className="card-title">{category.name}</h3>
                <p className="card-description">{category.description}</p>

                <div className="card-stats">
                  {category.stock !== undefined && (
                    <div className="stat">

                    </div>
                  )}
                  {category.records !== undefined && (
                    <div className="stat">
                      <span className="stat-label">Records:</span>
                      <span className="stat-value">{category.records}</span>
                    </div>
                  )}
                  {category.value !== undefined && (
                    <div className="stat">

                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {showMoreModal && (
        <div className="modal-overlay" onClick={() => setShowMoreModal(false)}>
          <div className="modal-content" onClick={(event) => event.stopPropagation()}>
            <div className="modal-header">
              <h2>More</h2>
              <button
                className="modal-close"
                onClick={() => setShowMoreModal(false)}
                aria-label="Close"
              >
                x
              </button>
            </div>

            <div className="more-options-grid">
              {moreOptions.map((option) => (
                <div
                  key={option.id}
                  className="more-option-card"
                  onClick={() => handleMoreOptionClick(option.path)}
                >
                  <div className="option-icon">{option.icon}</div>
                  <div className="option-name">{option.name}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inventory;
